var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',{staticClass:"mx-auto mb-8 pa-4 d-flex flex-column justify-start align-center",attrs:{"elevation":"3"}},[_c('CustomScenarioChart',{attrs:{"period":_vm.otherValues.lifeExpectancy,"category":"age"}})],1),_c('EstimatedCashFlowSavings'),_c('EquityChange'),_c('Summary')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }